import { jsx as t, jsxs as n, Fragment as i } from "react/jsx-runtime";
import { Icon as l } from "@tameeni/icons";
import { cn as a } from "@tameeni/shared-logic";
import { NavigationMenu as r, NavigationMenuList as s, NavigationMenuItem as o, NavigationMenuTrigger as d, NavigationMenuContent as C, NavigationMenuLink as c } from "@tameeni/ui";
function x(e) {
  return /* @__PURE__ */ t(
    r,
    {
      dir: e.locale === "en" ? "ltr" : "rtl",
      className: a("border-b border-slate-50 [&>*]:w-full"),
      children: /* @__PURE__ */ t(
        s,
        {
          className: a(
            "overflow-x-auto no-scrollbar ",
            e.centered && "justify-center"
          ),
          children: e.children
        }
      )
    }
  );
}
function g(e) {
  return /* @__PURE__ */ t(o, { className: "relative w-fit px-4", children: e.isMegaMenu ? /* @__PURE__ */ n(i, { children: [
    /* @__PURE__ */ n(
      d,
      {
        className: a(
          "transition-all relative flex items-center justify-center min-w-20 font-bold px-2 py-4 md:font-semibold gap-2 hover:text-blue-600 focus:text-blue-600 text-t3 hover:bg-transparent focus:bg-transparent rounded-none h-full",
          e.isActive ? "text-blue-600 border-b-[3px] border-b-blue-600" : "text-gray-700 md:border-b-transparent"
        ),
        children: [
          /* @__PURE__ */ t("span", { "aria-hidden": "true", children: /* @__PURE__ */ t(
            l,
            {
              width: "24",
              height: "24",
              className: "w-6 h-6",
              name: e.icon
            }
          ) }),
          /* @__PURE__ */ t("h3", { className: a("text-md text-nowrap", e.labelClassName), children: e.label })
        ]
      }
    ),
    /* @__PURE__ */ t(C, { className: "top-0 start-0 left-auto", children: e.megaMenuContent })
  ] }) : /* @__PURE__ */ n(
    c,
    {
      href: e.link,
      className: a(
        "transition-all relative flex items-center justify-center min-w-20 font-bold px-2 py-4 md:font-semibold gap-2 hover:text-blue-600 text-t3",
        e.isActive ? "text-blue-600 border-b-[3px] border-b-blue-600" : "text-gray-700 md:border-b-transparent"
      ),
      "aria-label": e.label,
      children: [
        /* @__PURE__ */ t("span", { "aria-hidden": "true", children: /* @__PURE__ */ t(
          l,
          {
            width: "24",
            height: "24",
            className: "w-6 h-6",
            name: e.icon
          }
        ) }),
        /* @__PURE__ */ t("h3", { className: a("text-md text-nowrap", e.labelClassName), children: e.label }),
        e.isNew && e.newBadge && /* @__PURE__ */ t(m, { label: e.newBadge })
      ]
    }
  ) });
}
const m = ({ label: e }) => /* @__PURE__ */ n("section", { className: "absolute -end-2 top-0 center size-4 p-1", children: [
  /* @__PURE__ */ t("div", { className: "absolute inset-0 m-auto -z-10", children: /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none", children: [
    /* @__PURE__ */ t(
      "path",
      {
        d: "M15.0901 6.81714C14.8439 6.63558 14.5336 6.4088 14.4961 6.26063C14.5118 5.97383 14.5937 5.69456 14.7354 5.44467C14.9524 4.94659 15.1764 4.43045 14.9274 4.00124C14.6783 3.57203 14.1121 3.50248 13.5674 3.44473C13.2851 3.44284 13.0069 3.37645 12.7542 3.25065C12.6282 2.99703 12.5621 2.71788 12.5608 2.43469C12.4996 1.89002 12.4363 1.32656 12.0043 1.07474C11.5723 0.82291 11.0555 1.04343 10.5574 1.26324C10.3072 1.40478 10.0278 1.48667 9.74077 1.50254C9.59052 1.46221 9.36445 1.15472 9.18426 0.908471C8.86846 0.482751 8.51298 0 7.99961 0C7.48624 0 7.13079 0.482751 6.81704 0.908471C6.6348 1.15541 6.4087 1.46498 6.26053 1.50323C5.97377 1.48596 5.69461 1.40415 5.44388 1.26392C4.94304 1.0434 4.42689 0.823595 3.99909 1.07125C3.57128 1.3189 3.49964 1.88653 3.43841 2.43466C3.43642 2.71687 3.37029 2.99495 3.24501 3.24785C2.99277 3.37185 2.71569 3.43701 2.43462 3.43844C1.88927 3.49964 1.32509 3.56297 1.07399 3.99495C0.822877 4.42693 1.04343 4.94313 1.26324 5.44189C1.4053 5.69261 1.48722 5.97287 1.50254 6.26063C1.46221 6.41088 1.15472 6.63767 0.908471 6.81714C0.482751 7.13017 0 7.48634 0 7.99971C0 8.51308 0.482751 8.86925 0.909189 9.18228C1.15544 9.36383 1.4657 9.59062 1.50326 9.73878C1.48748 10.0256 1.40557 10.3049 1.26396 10.5547C1.04692 11.0528 0.822942 11.569 1.07196 11.9982C1.32099 12.4274 1.88724 12.4969 2.43192 12.5547C2.71423 12.5566 2.99237 12.623 3.24511 12.7488C3.3711 13.0024 3.43726 13.2815 3.4385 13.5647C3.49971 14.1094 3.56303 14.6729 3.99501 14.9247C4.42699 15.1765 4.93968 14.9497 5.43844 14.7327C5.69111 14.5927 5.97223 14.5118 6.26066 14.4962C6.41092 14.5365 6.63698 14.844 6.81717 15.0903C7.13089 15.516 7.48637 15.9987 7.99974 15.9987C8.51311 15.9987 8.86856 15.516 9.18231 15.0903C9.36455 14.8433 9.59065 14.5337 9.73882 14.4955C10.0258 14.5117 10.3051 14.5936 10.5555 14.7348C11.0535 14.9518 11.5697 15.1745 11.9982 14.9275C12.4267 14.6805 12.4976 14.1122 12.5589 13.5668C12.5608 13.2846 12.627 13.0066 12.7523 12.7537C13.005 12.6286 13.2828 12.5627 13.5647 12.561C14.1101 12.4998 14.6743 12.4365 14.9254 12.0045C15.1765 11.5725 14.9497 11.0598 14.7334 10.561C14.5918 10.309 14.5108 10.0275 14.4969 9.73882C14.5372 9.58856 14.8447 9.36178 15.0909 9.18231C15.5167 8.86859 16.0001 8.51242 16.0001 7.99974C16.0001 7.48706 15.5165 7.13017 15.0901 6.81714Z",
        fill: "url(#paint0_linear_4079_62961)"
      }
    ),
    /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ n(
      "linearGradient",
      {
        id: "paint0_linear_4079_62961",
        x1: "-0.865679",
        y1: "5.56478",
        x2: "17.654",
        y2: "14.9022",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ t("stop", { offset: "0.0133967", stopColor: "#FFC874" }),
          /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#FFEB37" })
        ]
      }
    ) })
  ] }) }),
  /* @__PURE__ */ t("div", { className: "text-[4px] font-medium uppercase text-slate-900", children: e })
] });
export {
  x as MainNav,
  g as NavItem
};
//# sourceMappingURL=index.js.map
